import { Discount } from '@esportal/portal-service';
import { RenovadorTier } from '../models/hucha-values';

export const RENOVADOR_PLUS15 = '701Tr00000w5Vt3IAE';
export const RENOVADOR_STANDARD = '701QF00001fu4VTYAY';

export const getRenovadorTierFromDiscounts = (discounts: Discount[] = []): RenovadorTier | undefined => {
	const discountIds = discounts.map((discount) => discount.id);

	if (discountIds.includes(RENOVADOR_PLUS15)) return 'plus15';
	if (discountIds.includes(RENOVADOR_STANDARD)) return 'standard';

	return undefined;
};

export const getRenovadorDiscountId = (renovadorTier: string) => {
	switch (renovadorTier) {
		case 'plus15':
			return RENOVADOR_PLUS15;
		case 'standard':
			return RENOVADOR_STANDARD;
		default:
			return '';
	}
};
